'use client';

export const ViewMode = {
  Perspective: 'perspective',
  Top: 'top',
  Bottom: 'bottom',
  Front: 'front',
  Back: 'back',
  Left: 'left',
  Right: 'right',
} as const;
export type ViewMode = (typeof ViewMode)[keyof typeof ViewMode];

export const SelectMode = {
  Select: 'select',
  Translate: 'translate',
  Rotate: 'rotate',
  Scale: 'scale'
} as const;
export type SelectMode = (typeof SelectMode)[keyof typeof SelectMode];

export const InspectorMode = {
  Default: 'default',
  PrefabInstance: 'PrefabInstance',
  PrefabAsset: 'PrefabAsset',
} as const;
export type InspectorMode = (typeof InspectorMode)[keyof typeof InspectorMode];

export type CameraName = '' | 'prefab';